import { BoMItemType, MaterialHeaderRow } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'
import { BoMItemSatisfyActiveFilters } from 'utils/BoMItemSatisfyActiveFilters'
import { BomItemPointer } from './previousAndNextBomItemIdsSelector'

export const getPreviousAndNextItemByMaterialHeader = (
  state: RootAppState,
  bomItemId: string
) => {
  let previous: BomItemPointer = null
  let next: BomItemPointer = null

  if (!state.project.flatView) {
    return null
  }

  const materialIndex = state.project.materialHeadersIds.indexOf(bomItemId)

  if (materialIndex > -1) {
    if (materialIndex === 0) {
      previous = {
        bomItemId: state.project.activeProject?.id,
        bomItemType: BoMItemType.project,
      }
    } else {
      let previousMaterialHeaderId = null

      for (let i = materialIndex - 1; i >= 0; i--) {
        if (
          BoMItemSatisfyActiveFilters(
            state.project.filters,
            state.project.flatView[state.project.materialHeadersIds[i]]
          )
        ) {
          previousMaterialHeaderId = state.project.materialHeadersIds[i]
          break
        }
      }

      if (!previousMaterialHeaderId) {
        // previous will be the project
        previous = {
          bomItemId: state.project.activeProject?.id,
          bomItemType: BoMItemType.project,
        }
      } else {
        // previous will be the last partType (that satisfy the filters); of the previous assembly that satisfy the filters
        const partTypeIdsOfPreviousMaterialHeader = (
          state.project.flatView[previousMaterialHeaderId] as MaterialHeaderRow
        ).filteredPartTypeIds

        previous = {
          bomItemId:
            partTypeIdsOfPreviousMaterialHeader[
              partTypeIdsOfPreviousMaterialHeader.length - 1
            ],
          bomItemType: BoMItemType.row,
        }
      }
    }

    const materialHeader = state.project.flatView[
      bomItemId
    ] as MaterialHeaderRow

    if (materialHeader) {
      next = {
        bomItemId: materialHeader.filteredPartTypeIds[0],
        bomItemType: BoMItemType.row,
      }
    }

    return {
      previousBomItem: previous,
      nextBomItem: next,
    }
  }

  const bomItem = state.project.flatView && state.project.flatView[bomItemId]

  if (bomItem?.type === 'Row') {
    let rowMaterialHeader = undefined

    for (const materialHeaderId of state.project.materialHeadersIds) {
      const materialHeader = state.project.flatView[
        materialHeaderId
      ] as MaterialHeaderRow
      if (materialHeader.filteredPartTypeIds?.includes(bomItemId)) {
        rowMaterialHeader = materialHeader
        break
      }
    }

    if (rowMaterialHeader) {
      const rowIndex = rowMaterialHeader.filteredPartTypeIds.indexOf(bomItemId)

      if (rowIndex > -1) {
        if (rowIndex === 0) {
          // we don't have support for material details yet.
          // Call the function to get the previous
          previous = getPreviousAndNextItemByMaterialHeader(
            state,
            rowMaterialHeader.id
          ).previousBomItem

          // previous = {
          //   bomItemId: rowMaterialHeader.id,
          //   bomItemType: BoMItemType.materialHeader,
          // }
        } else {
          if (Boolean(rowMaterialHeader.filteredPartTypeIds[rowIndex - 1])) {
            previous = {
              bomItemId: rowMaterialHeader.filteredPartTypeIds[rowIndex - 1],
              bomItemType: BoMItemType.row,
            }
          }
        }

        if (rowIndex === rowMaterialHeader.filteredPartTypeIds.length - 1) {
          // last row of an assembly, next will be the next assembly header
          const parentMaterialHeaderIndex =
            state.project.materialHeadersIds.indexOf(rowMaterialHeader.id)

          let nextMaterialHeader = null

          for (
            let i = parentMaterialHeaderIndex + 1;
            i < state.project.materialHeadersIds.length;
            i++
          ) {
            if (
              BoMItemSatisfyActiveFilters(
                state.project.filters,
                state.project.flatView[state.project.materialHeadersIds[i]]
              )
            ) {
              nextMaterialHeader = state.project.materialHeadersIds[i]
              break
            }
          }

          if (nextMaterialHeader) {
            // for now we don't have details for material header.
            // Call the function again to get the next bom item
            next = getPreviousAndNextItemByMaterialHeader(
              state,
              nextMaterialHeader
            ).nextBomItem

            // next = {
            //   bomItemId: nextMaterialHeader,
            //   bomItemType: BoMItemType.materialHeader,
            // }
          }
        } else {
          if (Boolean(rowMaterialHeader.filteredPartTypeIds[rowIndex + 1])) {
            next = {
              bomItemId: rowMaterialHeader.filteredPartTypeIds[rowIndex + 1],
              bomItemType: BoMItemType.row,
            }
          }
        }
      }
    }
  }

  return {
    previousBomItem: previous,
    nextBomItem: next,
  }
}
